import React, { useEffect, useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight, FiGrid, FiChevronDown } from "react-icons/fi";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseurl, imgurl } from "../baseurl";
import "../assets/css/category.css";

function Category() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const scrollRef = useRef(null);
  const categoryRefs = useRef({});
  const megaMenuRef = useRef(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${baseurl}getCategoriesWithSubcategories`);
        if (res.data?.categories) setCategories(res.data.categories);
      } catch (err) {
        console.error("Error fetching categories:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const scrollLeft = () => scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  const scrollRight = () => scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });

  const handleMouseEnter = (id, isMega = false) => {
    if (isMega) {
      setShowMegaMenu(true);
      setActiveDropdown(null);
      return;
    }
    
    setShowMegaMenu(false);
    setActiveDropdown(id);
    if (categoryRefs.current[id]) {
      const rect = categoryRefs.current[id].getBoundingClientRect();
      setDropdownPosition({
        left: rect.left + rect.width / 2,
        top: rect.bottom,
      });
    }
  };

  return (
    <div className="category-wrapper">
      <div className="category-nav-container" onMouseLeave={() => {setActiveDropdown(null); setShowMegaMenu(false);}}>
        
        <button className="nav-btn left" onClick={scrollLeft}><FiChevronLeft /></button>

        <div className="category-container" ref={scrollRef}>
          {/* 🚀 1st PLACE: MEGA MENU TRIGGER */}
          {!loading && (
            <div 
              className={`category-card mega-trigger ${showMegaMenu ? 'active' : ''}`}
              onMouseEnter={() => handleMouseEnter(null, true)}
            >
              <div className="category-link">
                <div className="image-ring mega-icon-ring">
                  <FiGrid size={24} className="mega-icon" />
                </div>
                <span className="cat-label">All Categories</span>
              </div>
            </div>
          )}

          {loading ? (
            [...Array(8)].map((_, i) => (
              <div key={i} className="category-card skeleton-card">
                <div className="skeleton-circle"></div>
                <div className="skeleton-line"></div>
              </div>
            ))
          ) : (
            categories.map((cat) => (
              <div
                key={cat.id}
                className={`category-card ${activeDropdown === cat.id ? "active" : ""}`}
                ref={(el) => (categoryRefs.current[cat.id] = el)}
                onMouseEnter={() => handleMouseEnter(cat.id)}
              >
                <Link to={`/category/${cat.slug}`} className="category-link">
                  <div className="image-ring">
                    <img src={`${imgurl}${cat.image}`} alt={cat.name} className="cat-img" />
                  </div>
                  <span className="cat-label">{cat.name}</span>
                </Link>
              </div>
            ))
          )}
        </div>

        <button className="nav-btn right" onClick={scrollRight}><FiChevronRight /></button>

        {/* 🚀 THE MEGA MENU PANEL */}
        {showMegaMenu && (
          <div className="mega-menu-panel" onMouseEnter={() => setShowMegaMenu(true)}>
            <div className="mega-grid">
              {categories.map((cat) => (
                <div key={cat.id} className="mega-column">
                  <Link to={`/category/${cat.slug}`} className="mega-title">
                    {cat.name}
                  </Link>
                  <div className="mega-subs">
                    {cat.subcategories?.map((sub) => (
                      <Link key={sub.id} to={`/shop/${cat.slug}/${sub.slug}`} className="mega-sub-item">
                        {sub.name}
                      </Link>
                    ))}
                    <Link to={`/category/${cat.slug}`} className="view-all-small">View All →</Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Standard Floating Dropdown */}
        {categories.map((cat) =>
          cat.subcategories?.length > 0 && activeDropdown === cat.id && (
            <div
              key={`drop-${cat.id}`}
              className="glass-dropdown"
              style={{ top: dropdownPosition.top + 10, left: dropdownPosition.left }}
              onMouseEnter={() => setActiveDropdown(cat.id)}
            >
              <div className="dropdown-arrow"></div>
              <div className="dropdown-content">
                <p className="dropdown-header">Shop {cat.name}</p>
                <div className="subcategory-grid">
                  {cat.subcategories.map((sub) => (
                    <Link key={sub.id} className="sub-item" to={`/shop/${cat.slug}/${sub.slug}`}>
                      {sub.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default Category;